var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmbulance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1036,
    y: 23,
    width: 38,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.439962,
    y: -0.38332,
    width: 361905,
    height: 361905
  })), /*#__PURE__*/React.createElement("image", {
    width: 41,
    height: 41,
    xlinkHref: "data:image/png;base64,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",
    preserveAspectRatio: "none",
    id: "img2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 352381,
    height: 352381
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-1036 -23)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    transform: "matrix(0.000105 0 0 0.000105 1036 23)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    transform: "matrix(1.02702 0 0 1 -0.285156 0.00158692)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img2",
    transform: "scale(8594.66 8594.66)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmbulance);
export default __webpack_public_path__ + "static/media/Ambulance.8dbc602491918f3811bb8338ff5afdd4.svg";
export { ForwardRef as ReactComponent };